import React, { useState } from "react";
import { IconButton, Tooltip } from "@mui/material";
import HistoryIcon from "@mui/icons-material/History";
import MasterHistoryDialog from "./MasterHistoryDialog";
import { useMasterHistoryAccess } from "./useMasterHistoryAccess";

/** Row action that opens the record's change history. Renders nothing unless history is on and the user may see it. */
const MasterHistoryButton = ({ entityType, entityId, recordLabel, iconSize = 16 }) => {
  const { allowed, enabled } = useMasterHistoryAccess();
  // Mounted on first click only: a table can hold hundreds of these.
  const [mounted, setMounted] = useState(false);
  const [open, setOpen] = useState(false);

  if (!allowed || !enabled) return null;

  return (
    <>
      <Tooltip title="History">
        <IconButton
          size="small"
          aria-label="View change history"
          onClick={() => {
            setMounted(true);
            setOpen(true);
          }}
          sx={{
            p: 0.25,
            color: "#1E3A5F",
            "&:hover": { color: "#D4AF37", backgroundColor: "transparent" },
          }}
        >
          <HistoryIcon sx={{ fontSize: iconSize }} />
        </IconButton>
      </Tooltip>
      {mounted && (
        <MasterHistoryDialog
          open={open}
          onClose={() => setOpen(false)}
          entityType={entityType}
          entityId={String(entityId)}
          recordLabel={recordLabel}
        />
      )}
    </>
  );
};

export default MasterHistoryButton;
